import { all, call, put, takeLatest,delay } from 'redux-saga/effects';
import axios from 'axios';
import api from '../../services/api';
import types from '../types';
import notification from '../../services/notification';
import routes from '../../routes';


function* authLogin({ payload }) {
  try {
    const { data, status } = yield call(api.auth.login, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.LOGIN_SUCCESS, payload: data });
    // history.push(routes.Users.path);

     window.location.replace(routes.Root.path);

  } catch (error) {
    yield put({ type: types.LOGIN_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  } 
}

function* getAdmin() {
  try {
    const { data, status } = yield call(api.auth.getAdmin);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_ADMIN_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_ADMIN_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* authLogout() {
  try {
    // TODO
    // const { data, status } = yield call(api.auth.logout);
    // if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.LOGOUT_SUCCESS });
  } catch (error) {
    yield put({ type: types.LOGOUT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.error || 'Something went wrong',
    });
  } finally {
    delete axios.defaults.headers.common.Authorization;
  }
}

export function* auth() {
  yield all([
    takeLatest(types.GET_ADMIN_START, getAdmin),
    takeLatest(types.LOGIN_START, authLogin),
    takeLatest(types.LOGOUT_START, authLogout),
  ]);
}
